// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UoXmq{width:calc(100% + 8px);min-width:0;overflow-x:auto;overflow-y:visible;padding:12px 8px 12px 0;margin-right:-8px}.OYeg8{display:flex;flex-direction:row;flex-wrap:nowrap;width:100%;gap:16px}.hNmA8{flex:1 1 240px;min-width:240px}._4VDC{display:flex !important;flex-direction:row !important;flex-wrap:nowrap !important;grid-template-columns:unset !important;grid-template-rows:unset !important;grid-auto-flow:unset !important;grid-auto-columns:unset !important;gap:16px !important;width:100%;justify-content:start;overflow:visible !important}.B4bdd{flex:1 1 240px !important;min-width:240px !important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `UoXmq`,
	"staticStrip": `OYeg8`,
	"staticItem": `hNmA8`,
	"draggableGridOverride": `_4VDC`,
	"draggableGridItem": `B4bdd`
};
export default ___CSS_LOADER_EXPORT___;
